:host {
    width: 100%;
}

.side-rail {
    border: 1px solid var(--color-border);
    background-color: var(--color-foreground);
    border-radius: var(--border-small);
}
.side-rail a {
    text-decoration: none;
    color: var(--color-primary);
}

.dropdown-container {
    position: relative;
    display: inline-block;
    border: 1px solid var(--color-border);
    border-radius: var(--border-small);
    background-color: var(--color-foreground);
    height: 100%;
    width: auto;
}

.dropdown {
    background-color: var(--color-foreground);
    appearance: none;
    margin: 0px;
    padding: var(--spacing-small) calc(30px) var(--spacing-small) var(--spacing-small);
    width: 100%;
    height: 100%;
    border-radius: var(--border-small);
    border: 0px;
    outline: none;
    text-indent: 0px;
}

.dropdown-arrow {
    position: absolute;
    top: 50%;
    transform: translate(0px, -50%) rotate(90deg);
    right: 6px;
    pointer-events: none;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-small);
    border-bottom: 1px solid var(--color-border);
}

.title {
    margin: 0px;
    margin-right: var(--spacing-small);
}

.title-font {
    font-size: var(--font-size-title);
    font-weight: var(--font-weight-bold);
    line-height: 24px;
}
.list-container {
    list-style: none;
    padding-left: 0;
    margin: 0;
    min-height: 117px;
}

@media (min-width: 500px) {
    .list-container {
        min-height: 69px;
    }
}

.font {
    font-family: var(--font-family);
    font-size: var(--font-size-body);
}

.dropdown-font {
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    line-height: 18px;
    text-transform: capitalize;
    letter-spacing: 0.2px;
    color: var(--color-primary);
}

.dropdown-default-font {
    color: var(--color-secondary);
}

.empty-state {
    text-align: center;
    padding: var(--spacing-small);
}

.see-all {
    color: var(--color-info);
    font-weight: var(--font-weight-bold);
    background: none;
    border: none;
    cursor: pointer;
}

.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--spacing-small);
    gap: 0.25rem;
}

/* -------------------------- Copied from promotion-card for skeleton loading ----------------------- */
.item {
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: var(--spacing-small);
    border-bottom: 1px solid var(--color-border);
    gap: 0.5rem;
}

.item__shadow {
    border: 1px solid var(--color-border);
    border-radius: var(--border-small);
    margin: var(--spacing-small);
    box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
}

.item__content {
    display: flex;
    align-items: center;
    flex: 1;
    flex-basis: 250px;
    gap: var(--spacing-small);
}

.item__logo {
    width: 35px;
    height: 35px;
    align-self: center;
}

.item__description {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1;
}

.item__book-name, .featured-item__book-name {
    font-size: var(--font-size-subcaption);
    font-weight: var(--font-weight-bold);
    line-height: 14px;
    color: var(--color-secondary);
}

.item__cta, .featured-item__cta {
    color: var(--color-primary);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-bold);
    line-height: 18px;
}

.item__terms, .featured-item__terms {
    font-size: var(--font-size-tiny);
    line-height: 14px;
    color: var(--color-secondary);
}

.buttons {
    width: 100%;
    display: flex;
    flex: 1 1 200px;
    justify-content: space-between;
    gap: var(--spacing-small);
}

.button {
    border: 1px solid var(--color-border);
    padding: var(--spacing-small) 0;
    border-radius: var(--border-small);
    background: border-box var(--color-success);
    cursor: pointer;
    flex: 1 1 50%;
    align-self: center;
}

.button-font {
    color: var(--color-foreground);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
    line-height: 14px;
    text-align: center;
}

/* bonus code css */
.bonus {
    background-color: var(--color-background);
}

.featured-bonus {
    background-color: var(--color-brand-tertiary);
}

.bonus, .featured-bonus {
    flex: 1 1 50%;
    padding: var(--spacing-tiny);
    border: 1px dashed var(--color-border);
    border-radius: var(--border-small);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 22px;
    line-height: var(--spacing-smedium);
}

.bonus:hover {
    background-color: var(--color-background);
    border: 1px dashed var(--color-secondary);
}

.featured-bonus:hover {
    border: 1px dashed var(--color-secondary);
}

.bonus-code {
    color: var(--color-primary);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
}

.bonus-text {
    color: var(--color-secondary);
    font-size: var(--font-size-caption);
    font-weight: 800;
    font-size: 9px;
}

.bonus-copy {
    color: var(--color-info);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
}

.no-code {
    color: var(--color-secondary);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
    line-height: var(--spacing-smedium);
}

.featured-item {
    display: block;
    text-decoration: none;
}

.featured-item__content__header {
    font-size: var(--font-size-subcaption);
    margin: 0;
    padding: var(--spacing-tiny) var(--spacing-small);
    background-color: var(--color-brand-primary);
    color: var(--color-text-white);
}

.featured-item__content__container {
    background-color: var(--color-brand-secondary);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: var(--spacing-small);
    border-bottom: 1px solid var(--color-border);
    gap: 0.5rem;
}

.featured-item__content {
    display: flex;
    align-items: center;
    flex: 1;
    flex-basis: 250px;
    gap: var(--spacing-small);
}

/* skeleton css */
.skeleton-item__logo {
    width: 35px;
    height: 35px;
    border-radius: var(--border-small);
    align-self: center;
    background-color: var(--color-background);
    animation: var(--loading);
}

.skeleton-item__description {
    flex-grow: 1;
    gap: 2px;
}
.skeleton-item__description > *:nth-of-type(odd) {
    height: var(--font-size-caption);
    width: 75px;
    background-color: var(--color-background);
    animation: var(--loading);
}
.skeleton-item__description > *:nth-of-type(even) {
    height: var(--font-size-subcaption);
    width: 100%;
    margin-top: 2px;
    margin-bottom: 2px;
    background-color: var(--color-background);
    animation: var(--loading);
}

.skeleton-button {
    background-color: var(--color-background);
    animation: var(--loading);
}

.text-dark {
    color: var(--color-dark-primary);
}

.dark-mode .side-rail {
    border: 1px solid var(--color-dark-background);
    background-color: var(--color-dark-foreground);
    color: var(--color-dark-primary);
}

.dark-mode .dropdown-container,
.dark-mode .dropdown {
    background-color:  var(--color-dark-foreground);
}

.dark-mode .dropdown-font {
    color: var(--color-dark-primary);
}

.dark-mode .dropdown-default-font {
    color: var(--color-dark-secondary);
}

.dark-mode .item__book-name,
.dark-mode .featured-item__book-name {
    color: var(--color-dark-secondary);
}

.dark-mode .item__cta,
.dark-mode .featured-item__cta {
    color: var(--color-dark-primary);
}

.dark-mode .no-code {
    color: var(--color-dark-primary);
}
